<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">添加虚拟抵扣</div>
    <Form :model="formData" :label-width="90"  :rules="formRules" ref="formData">
      <FormItem label="项目名称" prop="projectId">
        <Select v-model="formData.projectId" :label-in-value="true" class="item-width" @on-change="chageProject" placeholder="请选择项目">
          <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="合同号" prop="contractCode">
        <Input v-model="formData.contractCode" class="item-width" >
        </Input>
      
      </FormItem>

    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>  
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import {getProjects} from '@/api/common'
import { getUid,addSpecialRules } from '@/api/managementCenter'

export default {
  created(){
    getProjects().then( res => {
      this.projectList = res.data
    })
  },
  props:{
    n:{
      type:Number,
      default:0
    }
  },
  watch:{
    n(val) {
      this.show = true
      this.projectName = ''

      this.$refs['formData'].resetFields();
    }
  },
  data() {
    return {
      loading:false,
      show: false,
      projectList:[],
      projectName:'',
      formData:{
        projectId:'',
        contractCode:null
      },
      formRules:{
        projectId:[{ required: true, message:'请选择项目', trigger:"change" }],
        contractCode:[{ required: true, message:'请输入有效的合同号', trigger: "blur" }]
      }
    }
  },
  methods:{
    close(){
      this.show = false
    },
    chageProject(project){
      this.projectName = project.label
    },
    save() {
    // 调接口
     this.$refs[`formData`].validate(bool => {
       if(bool) {
         let data = {
           ruleType: 3,
           projectId: this.formData.projectId,
           contractCode: this.formData.contractCode,
           projectName: this.projectName
         }
         this.loading = true
         addSpecialRules(data).then(res => {
           this.loading = false
            this.$Message.success('添加成功！')
            this.show = false
            this.$emit('refresh')
          }).catch( err => {
            this.loading = false
          })

       }
     })
    
    }

  }
}
</script>